// LAMS Packages

<template>
  <section class="lms3130-container">
    <div class="lms3130 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li><sym-link to="/resources">Resources</sym-link></li>
        <li><span aria-current="page">LAMS Packages</span></li>
      </Ul>

      <div class="p-2 lams curved border-lightgray mb-4">
        <h5 class="serif mb-0">
          <i class="fa fa-file-zip-o ml-1 mr-2"></i>LAMS Packages
        </h5>
      </div>

      <sym-tabs
        id="tabs"
        v-model="activeTabIndex"
        @changed="onActiveTabIndexChanged"
      >
        <sym-tab title=" PLA" icon="copy">
          <div class="table-scroll-wrapper">
            <table class="table-scroll mt-2">
              <thead class="info-light">
                <tr>
                  <th class="w-15">Package Name</th>

                  <th class="w-35">Details</th>
                  <th class="w-5"></th>
                  <th class="w-10">Version</th>
                  <th class="w-15">Released</th>
                </tr>
              </thead>

              <tbody class="white text-charcoal">
                <tr v-for="item in plaItems" :key="item.resourceId">
                  <td class="w-25">{{ item.resourceName }}</td>
                  <td class="w-15">
                    <a
                      class="button success sm-1"
                      :href="item.filePath"
                      download
                      ><i class="fa fa-download"></i
                      ><span class="button-caption ml-2">Download</span></a
                    >
                  </td>
                  <td class="w-35">{{ item.resourceDetails }}</td>
                  <td class="w-10">{{ item.version }}</td>
                  <td class="w-15">
                    {{ core.toDateDisplayFormat(item.releaseDate) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </sym-tab>

        <sym-tab title=" IVAS" icon="cube">
          <div class="table-scroll-wrapper">
            <table class="table-scroll mt-2">
              <thead class="info-light">
                <tr>
                  <th class="w-15">Package Name</th>

                  <th class="w-35">Details</th>
                  <th class="w-5"></th>
                  <th class="w-10">Version</th>
                  <th class="w-15">Released</th>
                </tr>
              </thead>

              <tbody class="white text-charcoal">
                <tr v-for="item in ivasItems" :key="item.resourceId">
                  <td class="w-25">{{ item.resourceName }}</td>
                  <td class="w-15">
                    <a
                      class="button success sm-1"
                      :href="item.filePath"
                      download
                      ><i class="fa fa-download"></i
                      ><span class="button-caption ml-2">Download</span></a
                    >
                  </td>
                  <td class="w-35">{{ item.resourceDetails }}</td>
                  <td class="w-10">{{ item.version }}</td>
                  <td class="w-15">
                    {{ core.toDateDisplayFormat(item.releaseDate) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </sym-tab>

        <sym-tab title=" Data Capture" icon="database">
          <div class="table-scroll-wrapper">
            <table class="table-scroll mt-2">
              <thead class="info-light">
                <tr>
                  <th class="w-15">Package Name</th>

                  <th class="w-35">Details</th>
                  <th class="w-5"></th>
                  <th class="w-10">Version</th>
                  <th class="w-15">Released</th>
                </tr>
              </thead>

              <tbody class="white text-charcoal">
                <tr v-for="item in dcItems" :key="item.resourceId">
                  <td class="w-25">{{ item.resourceName }}</td>
                  <td class="w-15">
                    <a
                      class="button success sm-1"
                      :href="item.filePath"
                      download
                      ><i class="fa fa-download"></i
                      ><span class="button-caption ml-2">Download</span></a
                    >
                  </td>
                  <td class="w-35">{{ item.resourceDetails }}</td>
                  <td class="w-10">{{ item.version }}</td>
                  <td class="w-15">
                    {{ core.toDateDisplayFormat(item.releaseDate) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </sym-tab>

        <sym-tab title=" Miscellaneous" icon="table">
          <div class="table-scroll-wrapper">
            <table class="table-scroll mt-2">
              <thead class="info-light">
                <tr>
                  <th class="w-15">Package Name</th>

                  <th class="w-35">Details</th>
                  <th class="w-5"></th>
                  <th class="w-10">Version</th>
                  <th class="w-15">Released</th>
                </tr>
              </thead>

              <tbody class="white text-charcoal">
                <tr v-for="item in miscItems" :key="item.resourceId">
                  <td class="w-25">{{ item.resourceName }}</td>
                  <td class="w-15">
                    <a
                      class="button success sm-1"
                      :href="item.filePath"
                      download
                      ><i class="fa fa-download"></i
                      ><span class="button-caption ml-2">Download</span></a
                    >
                  </td>
                  <td class="w-35">{{ item.resourceDetails }}</td>
                  <td class="w-10">{{ item.version }}</td>
                  <td class="w-15">
                    {{ core.toDateDisplayFormat(item.releaseDate) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </sym-tab>

        <!-- <sym-tab title=" e-SurveyPlan" icon="database">
          <div class="table-scroll-wrapper">
            <table class=" mt-2">
              <thead class="info-light">
                <tr>
                  <th class="w-15">Package Name</th>

                  <th class="w-35">Details</th>
                  <th class="w-5"></th>
                  <th class="w-10">Version</th>
                  <th class="w-15">Released</th>
                </tr>
              </thead>

              <tbody class="white text-charcoal">
                <tr v-for="item in surveyplanItems" :key="item.resourceId">
                  <td class="w-25">{{ item.resourceName }}</td>

                  <td class="w-10">{{ item.resourceDetails }}</td>
                  <td class="w-10">{{ item.version }}</td>
                  <td class="w-15">
                    {{ core.toDateDisplayFormat(item.releaseDate) }}
                  </td>
                  <td class="w-15">
                    <a
                      class="button success sm-1"
                      :href="item.filePath"
                      download
                      ><i class="fa fa-download"></i
                      ><span class="button-caption ml-2">Download</span></a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </sym-tab> -->
      </sym-tabs>
    </div>
  </section>
</template>

<script>
import { get } from "../../js/http";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3130",

  data() {
    return {
      plaItems: [],
      ivasItems: [],
      dcItems: [],
      miscItems: [],
      // policiesItems: [],
      surveyplanItems: [],
      activeTabIndex: 0,
      isLoaded: false,
    };
  },

  methods: {
    getTargetPath() {
      return {
        name: this.$options.name,
        query: {
          activeTab: this.activeTabIndex,
        },
      };
    },

    syncValues(p, q) {
      const me = this;

      if ("activeTab" in q) {
        let index = parseInt(q.activeTab);
        if (!isNaN(index)) {
          me.activeTabIndex = index;
        }
      }
    },

    loadData() {
      const me = this,
        wait = me.wait();

      me.isLoaded = false;
      me.getPackages()
        .then((items) => {
          me.stopWait(wait);
          if (items && items.length) {
            me.plaItems = items.filter((o) => o.sectionId === 1);
            me.ivasItems = items.filter((o) => o.sectionId === 2);
            me.dcItems = items.filter((o) => o.sectionId === 3);
            me.miscItems = items.filter((o) => o.sectionId === 4);
            me.surveyplanItems = items.filter((o) => o.sectionId === 5);
          } else {
            me.board = null;
          }
          me.isLoaded = true;
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    // API calls

    getPackages() {
      return get("api/packages");
    },

    // event handlers

    onActiveTabIndexChanged() {
      this.reload();
    },
  },

  mounted() {
    const me = this;

    me.$nextTick(() => {
      me.syncValues(me.params, me.query);
      me.replaceUrl();
      me.loadData();
    });
  },
};
</script>

<style scoped>
.lms3130-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms3130 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.table-scroll-wrapper {
  overflow-x: auto;
}

.table-scroll {
  /* display: block; */
  /* overflow-x: auto; */
  white-space: nowrap;
  width: -moz-available;
  width: -webkit-fill-available;

  /* width: vw; */
}

td,
th {
  vertical-align: top;
}

@media (max-width: 1024px) {
  .lms3130 {
    width: 90%;
    padding: 2rem;
  }
}

@media (max-width: 960px) {
  .lms3130-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms3130 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }
}

@media (max-width: 420px) {
  .lms3130 {
    padding: 0.5rem;
  }
}
</style>
